import {Component, Input} from '@angular/core';
import {ReflexiveField} from '../../reflexive-model/reflexive-field';

@Component({
  selector: 'app-gelios-info-data',
  templateUrl: './gelios-info-data.component.html',
})
export class GeliosInfoDataComponent {
  @Input() reflexiveField: ReflexiveField;
}
